import { POSITION_BOTTOM, pluckNumber, POSITION_RIGHT } from '../../../../fc-core/src/lib';

function _manageLegendSpace() {
  var a,
      b,
      c,
      d,
      e = this,
      f = e.config,
      g = e.getChildren('legend') && e.getChildren('legend')[0],
      h = e.getChildren('gLegend') && e.getChildren('gLegend')[0],
      i = e.getFromEnv('dataSource').colorrange,
      j = f.hasLegend,
      k = {},
      l = e.hasGradientLegend,
      m = e.getFromEnv('dataSource').chart,
      n = pluckNumber(m.mapbycategory, 0),
      o = l && i && pluckNumber(i.gradient);
  o && !n ? (a = h.conf, l = !0, f.gLegendEnabled = !0, d = .5, b = a.legendPosition) : (a = g && g.config, l = !1, f.gLegendEnabled = !1, b = a && a.legendPos, d = b === POSITION_RIGHT ? .8 : .4), c = b === POSITION_RIGHT ? f.availableWidth * d : f.availableHeight * d, l ? k = e.manageGradientLegendSpace(c) : !1 !== j && g && !g.getState('removed') && (k = g && g._manageLegendPosition(c)), e._allocateSpace({
    bottom: k && k.bottom || 0,
    right: k && k.right || 0
  });
}

function manageGradientLegendSpace(a) {
  var b,
      c,
      d,
      e,
      f = this,
      g = f.config,
      h = f.getFromEnv('gLegend'),
      i = h && h.conf;
  return g.gLegendPadding = pluckNumber(f.getFromEnv('chart-attrib').legendpadding, 10), d = Math.min(g.gLegendPadding, .5 * a), i ? (b = i.legendPosition, e = h.getLogicalSpace(a), c = b === POSITION_BOTTOM ? {
    bottom: (e.height || 0) + d
  } : {
    right: (e.width || 0) + d
  }) : c = {
    bottom: 0,
    right: 0
  }, c;
}

export { _manageLegendSpace, manageGradientLegendSpace };